import { COMPONENT_VALUE_TYPES as types, FONT_SIZES, APP_HANDLERS } from 'shared/constants';

const propsSchema = [
  {
    key: 'center_item',
    label: 'Button',
    type: types.OBJECT,
    children: [
      {
        key: 'label',
        label: 'Label',
        type: types.TEXT
      },
      {
        key: 'font_size',
        label: 'Font Size',
        type: types.ENUM,
        options: FONT_SIZES
      },
      {
        key: 'border_color',
        label: 'Border color',
        type: types.TEXT
      },
      {
        key: 'font_color',
        label: 'Font Color',
        type: types.TEXT
      },
      {
        key: 'padding',
        label: 'Padding',
        type: types.TEXT
      },
      {
        key: 'app_handler',
        label: 'Use App Handler',
        type: types.ENUM,
        options: APP_HANDLERS
      },
      {
        key: 'url',
        label: 'Url',
        type: types.TEXT
      },
      {
        key: 'open_new_tab',
        label: 'Open in new tab',
        type: types.BOOLEAN
      }
    ]
  },
  {
    key: 'left_item',
    label: 'Left Icon',
    type: types.OBJECT,
    children: [
      {
        key: 'icon',
        label: 'Icon',
        type: types.ICON
      },
      {
        key: 'source',
        label: 'Icon Image',
        type: types.S3_ASSET_URL
      },
      {
        key: 'size',
        label: 'Size',
        type: types.TEXT
      },
      {
        key: 'font_color',
        label: 'Font Color',
        type: types.TEXT
      },
      {
        key: 'app_handler',
        label: 'Use App Handler',
        type: types.ENUM,
        options: APP_HANDLERS
      },
      {
        key: 'url',
        label: 'Url',
        type: types.TEXT
      },
      {
        key: 'open_new_tab',
        label: 'Open in new tab',
        type: types.BOOLEAN
      },
      {
        key: 'meta_data',
        label: 'Meta Data',
        type: types.OBJECT,
        children: [
          {
            key: 'title',
            label: 'Title',
            type: types.TEXT
          },
          {
            key: 'description',
            label: 'Description',
            type: types.TEXT
          },
          {
            key: 'image',
            label: 'Image',
            type: types.S3_ASSET_URL
          }
        ]
      },
    ]
  },
  {
    key: 'right_item',
    label: 'Right Icon',
    type: types.OBJECT,
    children: [
      {
        key: 'icon',
        label: 'Icon',
        type: types.ICON
      },
      {
        key: 'source',
        label: 'Icon Image',
        type: types.S3_ASSET_URL
      },
      {
        key: 'size',
        label: 'Size',
        type: types.TEXT
      },
      {
        key: 'font_color',
        label: 'Font Color',
        type: types.TEXT
      },
      {
        key: 'app_handler',
        label: 'Use App Handler',
        type: types.ENUM,
        options: APP_HANDLERS
      },
      {
        key: 'url',
        label: 'Url',
        type: types.TEXT
      },
      {
        key: 'open_new_tab',
        label: 'Open in new tab',
        type: types.BOOLEAN
      },
      {
        key: 'meta_data',
        label: 'Meta Data',
        type: types.OBJECT,
        children: [
          {
            key: 'title',
            label: 'Title',
            type: types.TEXT
          },
          {
            key: 'description',
            label: 'Description',
            type: types.TEXT
          },
          {
            key: 'image',
            label: 'Image',
            type: types.S3_ASSET_URL
          }
        ]
      },
    ]
  },
  {
    key: 'background_color',
    label: 'Background Color',
    type: types.TEXT
  },
  {
    key: 'bar_height',
    label: 'Bar Height',
    type: types.TEXT
  },
  {
    key: 'padding_top',
    label: 'Padding Top',
    type: types.TEXT
  },
  {
    key: 'hide_before_scrolling',
    label: 'Hide Before Scrolling',
    type: types.BOOLEAN
  }
];

const defaultProps = {
  center_item: {
    label: 'Preorder Now',
    font_size: '14',
    border_color: '#7e7e7d',
    font_color: '#7e7e7d',
    padding: '5px 17px',
    app_handler: 'None',
    url: 'https://www.ff.com/us/reserve',
    open_new_tab: false
  },
  left_item: {
    icon: 'ff-icon-cube',
    source: '',
    size: '24px',
    font_color: '#7e7e7d',
    app_handler: 'None',
    url: 'https://www.ff.com/us/3D-tour',
    open_new_tab: false,
    meta_data: {
      title: '',
      description: '',
      image: ''
    }
  },
  right_item: {
    icon: 'ff-icon-share-arrow',
    source: '',
    size: '24px',
    font_color: '#7e7e7d',
    app_handler: 'None',
    url: 'https://www.ff.com/us/3D-tour',
    open_new_tab: false,
    meta_data: {
      title: '',
      description: '',
      image: ''
    }
  },
  background_color: '#1f1e1c',
  bar_height: '80px',
  padding_top: '0px',
  hide_before_scrolling: false
};

export default {
  title: 'Sticky Bar',
  id: 'StickyBar',
  propsSchema,
  defaultProps
};
